import { Link } from 'react-router-dom';

interface City {
  id: string;
  name: string;
  seoTitle: string;
  region: string;
  highlight?: boolean;
  description: string;
  services: string[];
  icon: string;
}

const cities: City[] = [
  {
    id: 'ratingen',
    name: 'Ratingen',
    seoTitle: 'Gebäudereinigung & Facility Service Ratingen',
    region: 'Hauptstandort · Kreis Mettmann',
    highlight: true,
    icon: 'ri-map-pin-2-fill',
    services: ['Gebäudereinigung', 'Facility Management', 'Garten- & Landschaftsbau', 'Renovierung'],
    description:
      'Als Hauptsitz von IGM Facility Service ist Ratingen unser Heimatmarkt. Seit 2010 betreuen wir Privat- und Gewerbekunden in Ratingen mit dem vollständigen Leistungsportfolio — von wöchentlicher Gebäudereinigung über professionelles Facility Management bis hin zu Garten- und Landschaftsgestaltung sowie vollständigen Renovierungsarbeiten. Kurze Anfahrtswege bedeuten für Ratinger Kunden schnelle Reaktionszeiten und besonders attraktive Konditionen.',
  },
  {
    id: 'duesseldorf',
    name: 'Düsseldorf',
    seoTitle: 'Gebäudereinigung Düsseldorf — IGM Facility Service',
    region: 'Landeshauptstadt NRW',
    icon: 'ri-building-2-line',
    services: ['Büroreinigung', 'Unterhaltsreinigung', 'Grundreinigung', 'Außenreinigung'],
    description:
      'Düsseldorf ist eines unserer wichtigsten Einsatzgebiete. IGM Facility Service übernimmt die professionelle Gebäudereinigung für Büros, Praxen und Gewerbeobjekte in der Landeshauptstadt — zuverlässig, termingetreu und nach verbindlichem Festpreisangebot. Auch Garten- und Landschaftsgestaltung sowie Renovierungsarbeiten führen wir regelmäßig in Düsseldorf und den umliegenden Stadtteilen durch.',
  },
  {
    id: 'moenchengladbach',
    name: 'Mönchengladbach',
    seoTitle: 'Reinigungsservice Mönchengladbach — IGM Facility Service',
    region: 'Rheinland · NRW',
    icon: 'ri-map-pin-line',
    services: ['Unterhaltsreinigung', 'Grundreinigung', 'Außenanlagenpflege', 'Facility Management'],
    description:
      'In Mönchengladbach ist IGM Facility Service für Unternehmen und Privatkunden tätig — ob regelmäßige Unterhaltsreinigung, einmalige Grundreinigung oder Außenanlagenpflege. Die Fahrtzeit von unserem Standort in Ratingen nach Mönchengladbach beträgt rund 30 Minuten, sodass wir flexibel und kurzfristig für unsere Kunden in Mönchengladbach vor Ort sein können. Kamps Bäckerei ist nur eines von vielen Unternehmen, das uns regelmäßig für Reinigungsleistungen in Mönchengladbach beauftragt.',
  },
  {
    id: 'wuppertal',
    name: 'Wuppertal',
    seoTitle: 'Facility Service & Reinigung Wuppertal',
    region: 'Bergisches Land · NRW',
    icon: 'ri-map-pin-line',
    services: ['Gebäudereinigung', 'Hausmeisterdienste', 'Malerarbeiten', 'Bodenbeläge'],
    description:
      'Wuppertal und das Bergische Land gehören fest zu unserem Einsatzgebiet. IGM Facility Service reinigt Büro- und Gewerbegebäude, übernimmt Hausmeisterdienste und führt Renovierungsarbeiten im Raum Wuppertal durch. Besonders gefragt sind unsere Leistungen rund um Malerarbeiten und Bodenbeläge — sauber, pünktlich und zum Festpreis.',
  },
  {
    id: 'hagen',
    name: 'Hagen',
    seoTitle: 'Gebäudereinigung & Renovierung Hagen',
    region: 'Südwestfalen · NRW',
    icon: 'ri-map-pin-line',
    services: ['Renovierungsarbeiten', 'Gebäudereinigung', 'Trockenbau', 'Malerarbeiten'],
    description:
      'Auch in Hagen und der Region Südwestfalen ist IGM Facility Service aktiv. Unternehmen wie HAEP haben uns für Renovierungsarbeiten in Hagen beauftragt — alles wurde exakt wie abgesprochen umgesetzt, ohne böse Überraschungen. Für Kunden in Hagen bieten wir Gebäudereinigung, Facility Management und Renovierungsleistungen zu transparenten Festpreisen an.',
  },
  {
    id: 'mettmann',
    name: 'Mettmann',
    seoTitle: 'Reinigungsservice & Hausmeisterdienste Mettmann',
    region: 'Kreis Mettmann · NRW',
    icon: 'ri-map-pin-line',
    services: ['Gebäudereinigung', 'Gartenpflege', 'Hausmeisterdienste', 'Facility Management'],
    description:
      'Der Kreis Mettmann liegt direkt vor unserer Haustür. Kunden aus Mettmann profitieren von besonders kurzen Reaktionszeiten und zuverlässiger Betreuung. Wir übernehmen Reinigungsservices für Büros und Wohnanlagen sowie Garten- und Außenanlagenpflege in Mettmann — regelmäßig und zu fairen Preisen.',
  },
  {
    id: 'velbert',
    name: 'Velbert',
    seoTitle: 'Facility Management & Reinigung Velbert',
    region: 'Niederbergisches Land · NRW',
    icon: 'ri-map-pin-line',
    services: ['Gebäudereinigung', 'Hausmeisterservice', 'Unterhaltsreinigung', 'Grundreinigung'],
    description:
      'Velbert im Niederbergischen Land ist ein fester Bestandteil unseres Servicenetzwerks. Für Gewerbetreibende, Verwaltungen und Privatpersonen in Velbert bietet IGM Facility Service professionelle Gebäudereinigung und Hausmeisterservices — pünktlich, zuverlässig und zu fairen, transparenten Preisen ohne versteckte Kosten.',
  },
  {
    id: 'solingen',
    name: 'Solingen',
    seoTitle: 'Gebäudereinigung & Renovierung Solingen',
    region: 'Bergisches Land · NRW',
    icon: 'ri-map-pin-line',
    services: ['Unterhaltsreinigung', 'Renovierungsarbeiten', 'Malerarbeiten', 'Gartenbau'],
    description:
      'Solingen in der Metropolregion Rheinland gehört ebenfalls zu unserem Einzugsgebiet. IGM Facility Service übernimmt in Solingen sowohl die laufende Unterhaltsreinigung als auch projektbezogene Leistungen wie Renovierungen, Malerarbeiten und Gartenanlagen — alles aus einer Hand und nach verbindlichem Festpreisangebot.',
  },
  {
    id: 'remscheid',
    name: 'Remscheid',
    seoTitle: 'Reinigungsservice & Außenanlagen Remscheid',
    region: 'Bergisches Land · NRW',
    icon: 'ri-map-pin-line',
    services: ['Gebäudereinigung', 'Grundreinigung', 'Außenanlagenpflege', 'On-Demand-Service'],
    description:
      'In Remscheid sind wir vor allem für gewerbliche Kunden tätig. Regelmäßige Gebäudereinigung und On-Demand-Leistungen wie Grundreinigungen und Außenanlagenpflege gehören zu unserem Angebot für Kunden in Remscheid. Sprechen Sie uns direkt an — wir erstellen Ihnen innerhalb von 24 Stunden ein kostenloses Festpreisangebot.',
  },
  {
    id: 'erkrath',
    name: 'Erkrath',
    seoTitle: 'Büroreinigung & Gebäudeservice Erkrath',
    region: 'Kreis Mettmann · NRW',
    icon: 'ri-map-pin-line',
    services: ['Büroreinigung', 'Praxisreinigung', 'Wohnungsreinigung', 'Unterhaltsreinigung'],
    description:
      'Erkrath liegt nur wenige Kilometer von unserem Standort in Ratingen entfernt und ist deshalb eines unserer am häufigsten bedienten Stadtgebiete. Wir reinigen Büros, Praxen und Wohnanlagen in Erkrath und Hochdahl — regelmäßig, verlässlich und mit dem Qualitätsanspruch, den unsere Kunden seit über einem Jahrzehnt schätzen.',
  },
  {
    id: 'hilden',
    name: 'Hilden',
    seoTitle: 'Gebäudereinigung & Fensterreinigung Hilden',
    region: 'Kreis Mettmann · NRW',
    icon: 'ri-map-pin-line',
    services: ['Gebäudereinigung', 'Fensterreinigung', 'Büroreinigung', 'Grundreinigung'],
    description:
      'Hilden im Kreis Mettmann schätzt unsere Flexibilität und Qualität. Von der einmaligen Fensterreinigung bis zur wöchentlichen Büroreinigung — IGM Facility Service ist in Hilden für Privat- und Gewerbekunden tätig und reagiert schnell auf kurzfristige Anfragen. Rufen Sie uns an oder senden Sie uns eine Nachricht für ein kostenloses Angebot.',
  },
  {
    id: 'langenfeld',
    name: 'Langenfeld',
    seoTitle: 'Facility Service & Gartenpflege Langenfeld',
    region: 'Rhein-Wupper · NRW',
    icon: 'ri-map-pin-line',
    services: ['Gebäudereinigung', 'Gartenpflege', 'Renovierungsarbeiten', 'Facility Management'],
    description:
      'Langenfeld an der Rhein-Wupper-Route ist Teil unseres engmaschigen Servicegebiets. Kunden in Langenfeld erhalten alle Leistungen von IGM Facility Service — Gebäudereinigung, Gartenpflege und Renovierungsarbeiten — zu transparenten Festpreisen ohne versteckte Kosten. Schnelle Reaktionszeiten und persönliche Betreuung sind für uns in Langenfeld selbstverständlich.',
  },
];

function CityCard({ city }: { city: City }) {
  return (
    <article
      id={city.id}
      className={`rounded-2xl border p-6 sm:p-8 flex flex-col gap-5 scroll-mt-28 ${
        city.highlight
          ? 'bg-[#0D2B4E] border-[#0D2B4E] text-white'
          : 'bg-white border-gray-200 hover:border-[#0D2B4E]/20 transition-colors'
      }`}
    >
      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div>
          {city.highlight && (
            <span className="inline-block bg-[#C8A96E] text-white text-[11px] font-bold px-3 py-0.5 rounded-full mb-2">
              Hauptstandort
            </span>
          )}
          <h2 className={`text-xl sm:text-2xl font-bold leading-tight mb-1 ${city.highlight ? 'text-white' : 'text-gray-900'}`}>
            {city.seoTitle}
          </h2>
          <div className="flex items-center gap-1.5">
            <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
              <i className={`${city.icon} text-sm ${city.highlight ? 'text-[#C8A96E]' : 'text-[#C8A96E]'}`} />
            </div>
            <span className={`text-xs font-medium ${city.highlight ? 'text-white/60' : 'text-gray-400'}`}>
              {city.region}
            </span>
          </div>
        </div>
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
          city.highlight ? 'bg-white/10' : 'bg-[#F8F7F4] border border-gray-200'
        }`}>
          <i className={`${city.icon} text-xl ${city.highlight ? 'text-[#C8A96E]' : 'text-[#0D2B4E]'}`} />
        </div>
      </div>

      {/* Description */}
      <p className={`text-sm leading-relaxed ${city.highlight ? 'text-white/75' : 'text-gray-600'}`}>
        {city.description}
      </p>

      {/* Service chips */}
      <div className="flex flex-wrap gap-2">
        {city.services.map((s) => (
          <span
            key={s}
            className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full ${
              city.highlight
                ? 'bg-white/10 text-white/80 border border-white/15'
                : 'bg-[#F8F7F4] text-gray-600 border border-gray-200'
            }`}
          >
            <i className="ri-tools-line text-[10px]" />
            {s}
          </span>
        ))}
      </div>

      {/* CTA */}
      <div className="pt-2 border-t border-dashed border-opacity-20 mt-auto
        border-white/10">
        <Link
          to="/kontakt"
          className={`inline-flex items-center gap-2 text-sm font-semibold transition-colors cursor-pointer ${
            city.highlight
              ? 'text-[#C8A96E] hover:text-white'
              : 'text-[#0D2B4E] hover:text-[#C8A96E]'
          }`}
        >
          <i className="ri-arrow-right-circle-line text-base" />
          Anfrage für {city.name} stellen
        </Link>
      </div>
    </article>
  );
}

export default function CityGrid() {
  return (
    <section className="py-16 sm:py-20 bg-[#F8F7F4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Quick nav */}
        <div className="mb-10 sm:mb-12">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">Direkt zur Stadt springen</p>
          <div className="flex flex-wrap gap-2">
            {cities.map((c) => (
              <a
                key={c.id}
                href={`#${c.id}`}
                className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                  c.highlight
                    ? 'bg-[#0D2B4E] text-white border-[#0D2B4E]'
                    : 'bg-white text-gray-700 border-gray-200 hover:border-[#0D2B4E]/30 hover:text-[#0D2B4E]'
                }`}
              >
                <i className={`${c.icon} text-[10px]`} />
                {c.name}
              </a>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 gap-5 sm:gap-6">
          {cities.map((city) => (
            <CityCard key={city.id} city={city} />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 bg-[#0D2B4E] rounded-2xl px-6 sm:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <p className="text-white font-bold text-lg sm:text-xl mb-1">Ihr Ort nicht dabei?</p>
            <p className="text-white/60 text-sm">
              Kein Problem — wir sind NRW-weit tätig und prüfen gerne Ihren Standort. Jetzt Anfrage stellen.
            </p>
          </div>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 bg-[#C8A96E] text-white px-7 py-3.5 rounded-xl font-bold text-sm hover:bg-[#b8996e] transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            Kostenlose Anfrage
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
